/** Calculates the cumulative duration of a task. */
// @ts-check
import { useMemo } from 'react';
import { useTasksContext } from '@/features/tasks/context/TasksContext.def';
import { getTaskRollupInfo } from '@/features/tasks/utils/structure/taskRollupUtils';

/**
 * @param {Task} task
 */
const useTaskRollup = (task) => {
  const { taskTree } = useTasksContext();
  return useMemo(() => getTaskRollupInfo(task, taskTree), [taskTree, task]);
};

export default useTaskRollup;
